// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-margin-20[data-v-bccd9d64]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
